<template>
  <ModalContainer :show="show" @close="onCancel">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <template slot="header">
      <h4 class="mb-0">{{ $t("add-vehicle") }}</h4>
    </template>

    <template slot="body">
      <form class="p-2" @submit.prevent="addvehicle">
        <div class="form-group">
          <label for="name"> {{ $t("vehicle-name") }}</label>
          <input
            type="text"
            name="name"
            v-model="name"
            class="form-control"
            required
            id="receiver-name"
            :placeholder="$t('enter-vehicle-name')"
            @keypress="isLetter($event)"
            style="text-transform: capitalize;"
          />
        </div>

        <div class="form-group">
          <label for="plateNumber"> {{ $t("plate_number") }}</label>
          <input
            v-model="plateNumber"
            type="text"
            name="plateNumber"
            class="form-control"
            required
            id="plateNumber"
            :placeholder="$t('enter-plate-number')"
          />
        </div>

        <div class="form-group">
          <label for="vehicle"> {{ $t("vehicle-type") }} </label>
          <select
            v-model="selectedVehicle"
            name="vehicle"
            class="form-control"
            required
            id="vehicle"
          >
            <option value="" disabled>{{ $t("select-vehicle") }}</option>
            <option v-for="vehicle in vehicles" :key="vehicle.id" :value="vehicle.name">
              {{ vehicle.name }}
            </option>
          </select>
        </div>

        <div type="submit" class="btn-add">
          <button>{{ $t("add") }}</button>
        </div>
      </form>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "AddVehicle",
  components: {
    ModalContainer,
    Loading,
  },
  props: {
    show: Boolean,
    onCancel: Function,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      name: "",
      plateNumber: "",

      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      selectedVehicle: "",
    };
  },
  computed: {
    ...mapGetters([]),
    vehicles() {
      return  [
        { id: 1, name: this.$t('truck') },
        { id: 2, name: this.$t('car') },
        { id: 3, name: this.$t('motorcycle') },
      ]
    },
  },
  methods: {
    ...mapActions(["addVehicles", "getVehicles"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },

    addvehicle() {
      this.isLoading = true;
      const newVehicle = {
        name: this.name,
        plateNumber: this.plateNumber,
        type: this.selectedVehicle.toLowerCase(),
      };
      this.addVehicles(newVehicle)
        .then((res) => {
          this.getVehicles();
          this.isLoading = false;
          this.onCancel();
          this.$emit("showSuccessPopup", {
            msg: this.$t("add_vehicle_mssg"),
            heading: this.$t("add_vehicle_heading"),
          });
        })
        .catch((error) => {
          console.error("Error adding vehicle:", error);
          this.isLoading = false;
          this.Errormssg = "Error adding vehicle. Please try again.";
        });
    },
  },
};
</script>

<style scoped>
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  background-color: rgba(33, 62, 122, 1);
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}
</style>
